import { Bunkering } from 'src/types/ViewModel/Bunkering/Bunkering';
import { bunkeringInputFields } from '../../BunkeringUtils';
import { FuelType } from 'src/types/ViewModel/Bunkering/FuelType';
import { BunkeringStatusEnum } from 'src/types/ViewModel/Bunkering/BunkeringEvent';
import { BUNKERING_INPUT_FIELD_KEYS } from 'src/enums/bunkering/bunkeringInputFieldKeys';
import { BiofuelGrade, getBiofuelGrade } from 'src/types/ViewModel/Bunkering/BiofuelGrade';

export const LOCKED_FOR_CHANGE_STATUSES = [BunkeringStatusEnum.InUse, BunkeringStatusEnum.Spent, BunkeringStatusEnum.Debunkered];

export const verifyAllFieldsValid = (bunkering: Bunkering): string[] => {
    const invalidFields = [] as string[];
    const isBioFuel = bunkering?.fuelType === FuelType.BIO;
    bunkeringInputFields.forEach((field) => {
        if (!isBioFuel && field.bioFuel) {
            return;
        } else if (field.key === BUNKERING_INPUT_FIELD_KEYS.BIOFUEL_VOLUME) {
            return;
        } else if (
            bunkering.biofuelGrade === getBiofuelGrade(BiofuelGrade.B100) &&
            field.key === BUNKERING_INPUT_FIELD_KEYS.BIO_BLEND_FOSSIL_FUEL_TYPE
        ) {
            return;
        } else {
            const value = bunkering?.[field.key];
            if (value === undefined || value === null) {
                invalidFields.push(field.label);
            } else if (field.inputType === 'number' && isNaN(value)) {
                invalidFields.push(field.label);
            } else if (field.inputType === 'checkbox' && typeof value !== 'boolean') {
                invalidFields.push(field.label);
            } else if (field.inputType === 'text' && value.length === 0) {
                invalidFields.push(field.label);
            } else if (field.min && value < field.min) {
                invalidFields.push(field.label);
            } else if (field.max && value > field.max) {
                invalidFields.push(field.label);
            }
        }
    });
    return invalidFields;
};

export const validateLiterWeight = (bunkering: Bunkering): boolean => {
    const literWeightField = bunkeringInputFields.find((field) => field.key === BUNKERING_INPUT_FIELD_KEYS.BDN_LITER_WEIGHT);
    return !!bunkering?.bdnLiterWeight && bunkering.bdnLiterWeight >= literWeightField.min && bunkering.bdnLiterWeight <= literWeightField.max;
};

export const getInvalidFieldsText = (invalidFields: string[]): string => {
    if (invalidFields.length > 3) {
        return `${[...invalidFields].splice(0, 3).join(', ')} and ${invalidFields.length - 3} more`;
    } else {
        return invalidFields.join(', ');
    }
};
